import classnames from 'classnames/bind'
import { useRouter } from 'next/router'
import { ReactNode } from 'react'

// Components
import Loading, { LoadingProps } from '@/components/common/livemallclub/Loading'
import Empty from '@/components/pages/livemallclub/Profile/component/MemberItemList/shared/Empty'
import AllEmpty from '../EmptyPrompt/AllEmpty'
import TypeEmpty from '../EmptyPrompt/TypeEmpty'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

type StatusPromptProps = {
  isFetching: boolean
  isEmpty: boolean
  children: ReactNode
  type?: 'all' | 'single' | 'profile_lives' | 'profile_shop'
  position?: LoadingProps['position']
}

const EmptyComponentMap = {
  all: <AllEmpty />,
  single: <TypeEmpty />,
  profile_lives: <Empty type='lives' />,
  profile_shop: <Empty type='shop' />,
}

const EmptyComponent = ({ type }: { type: keyof typeof EmptyComponentMap }) => {
  return EmptyComponentMap[type]
}

export const StateHandler = ({ isFetching, isEmpty, children, type = 'single', position }: StatusPromptProps) => {
  const { category: searchParamCategory } = useRouter().query
  const isAllCategory = searchParamCategory === 'all' || !searchParamCategory

  // 在 All 頁面，種類沒有資料時，不顯示任何東西
  if (type === 'single' && isEmpty && isAllCategory) return null

  if (isFetching)
    return (
      <div className={cx('loading-container')}>
        <Loading isFull={false} position={position} />
      </div>
    )
  if (!isFetching && isEmpty) return <EmptyComponent type={type} />
  return <>{children}</>
}
